import { File as FileType } from '@/clients/pages/FolderPage/types';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store';

export const selectFoldersState = (state: RootState) => state.folders;

export const selectAllFolders = createSelector(
  [selectFoldersState],
  (foldersState) => foldersState.folders
);

export const selectFoldersLoading = createSelector(
  [selectFoldersState],
  (foldersState) => foldersState.isLoading
);

export const selectFoldersError = createSelector(
  [selectFoldersState],
  (foldersState) => foldersState.error
);

export const selectFolderById = (folderId: string) =>
  createSelector([selectAllFolders], (folders) =>
    folders.find((folder: any) => folder.id === folderId)
  );

export const selectFileInFolder = (folderId: string, fileId: string) =>
  createSelector([selectFolderById(folderId)], (folder) =>
    folder?.files.find((file: FileType) => file.id === fileId)
  );

export const selectFolderByFolderName = (folderName: string) =>
  createSelector([selectAllFolders], (folders) =>
    folders.find(
      (folder: any) =>
        folder.folderName === folderName || folder.id === folderName
    )
  );
